import React from 'react';
import { Button, Card, Col, Row } from 'reactstrap';
import { Route } from 'react-router';
import { Link } from 'react-router-dom';
import { compact } from 'underscore';
import URI from 'urijs';
import cx from 'classnames';
import FontAwesome from 'react-fontawesome';

// modules
import BS from '../../theme/Bootstrap';
import styles from './brokerage-card.module.scss';
import propertyCardStyles from '../property-card/property-card.module.scss';

// images
import notfound from './images/notfound.png';
const PHOTO_BASE_URL = '//memberphotos.naplesarea.com/';

function BrokerageCard({
  data,
  className,
  imageAlign = 'left',
  tag = Card,
  searchURI,
  detailURI
}) {
  const Tag = tag;
  const renderProps = {
    imageAlign,
    searchURI,
    detailURI
  };

  return (
    <Tag className={cx(className, styles.agentCard, propertyCardStyles.propertyCard)}>
      <Row className={cx(BS.noGutters, BS.alignItemsCenter, BS.mb3)}>
        {imageAlign === 'right' &&
          renderDetails(data, {
            ...renderProps,
            children: renderAdditional(data, renderProps)
          })}
        {imageAlign === 'right' && renderImage(data, renderProps)}
        {imageAlign === 'left' && renderImage(data, renderProps)}
        {imageAlign === 'left' &&
          renderDetails(data, {
            ...renderProps,
            children: renderAdditional(data, renderProps)
          })}
      </Row>
    </Tag>
  );
}

function renderAddress(office) {
  return (
    <p className={BS.mb0}>
      {compact([office.address1, office.address2]).map((address, i, allItems) => (
        <span key={i}>
          {address}
          {i < allItems.length - 1 && <br />}
        </span>
      ))}
      <br />
      {office.city}, {office.state} {office.zip}
    </p>
  );
}

function renderAdditional(data, { searchURI, detailURI }) {
  return (
    <div>
      <Route path={`/firm/${encodeURIComponent(data.id)}`}>
        {props =>
          !props.match && (
            <div>
              <Link
                to={URI(`/firm/${encodeURIComponent(data.id)}`)
                  .search({
                    searchURI,
                    detailURI
                  })
                  .toString()}
                className={` ${BS.textUnderline}`}
              >
                View Office
              </Link>
            </div>
          )
        }
      </Route>
      {data.officeType === 'brokerage' && (
        <div>
          <Link
            to={URI(`/firm/${encodeURIComponent(data.id)}/listings`)
              .search({
                searchURI,
                detailURI
              })
              .toString()}
            className={` ${BS.textUnderline}`}
          >
            View Active Listings
          </Link>
        </div>
      )}
      {data.officeType === 'brokerage' && (
        <div>
          <Link
            to={URI(`/firm/${encodeURIComponent(data.id)}/recently_sold`)
              .search({
                searchURI,
                detailURI
              })
              .toString()}
            className={` ${BS.textUnderline}`}
          >
            View Recently Sold
          </Link>
        </div>
      )}
      {data.officeType === 'brokerage' && (
        <div>
          <Link
            to={URI(`/firm/${encodeURIComponent(data.id)}/agents`)
              .search({
                searchURI,
                detailURI
              })
              .toString()}
            className={` ${BS.textUnderline}`}
          >
            View Agents
          </Link>
        </div>
      )}
    </div>
  );
}

function renderDetails(data, { searchURI, detailURI, children, imageAlign }) {
  const officeDetailPath = URI(`/firm/${encodeURIComponent(data.id)}`)
    .search({
      searchURI,
      detailURI
    })
    .toString();
  return (
    <Col
      xs={6}
      className={cx({
        [BS.pl1]: imageAlign === 'left'
      })}
    >
      <h5>
        <Link to={officeDetailPath}>{data.company}</Link>
      </h5>
      {/*<p>
        {compact([data.phone, data.phone2]).map((phone, i, allItems) => (
          <span key={i}>
            {phone}
            {i < allItems.length - 1 && <br />}
          </span>
        ))}
      </p>*/}
      <p>
        {data.phone && (
          <Button
            color="link"
            href={`tel://${data.phone}`}
            className={`${BS.p0} ${BS.textUnderline}`}
          >
            {data.phone}
          </Button>
        )}
        {data.website && (
          <React.Fragment>
            <br />
            <Button
              color="link"
              href={URI(data.website).toString()}
              target="_blank"
              rel="noopener noreferrer"
              className={`${BS.p0} ${BS.textUnderline}`}
            >
              Visit Website
            </Button>
          </React.Fragment>
        )}
        {false && data.phone && data.fax && <br />}
        {false && data.fax && (
          <span title="Fax">
            <FontAwesome name="fax" fixedWidth /> {data.fax}
          </span>
        )}
      </p>
      {renderAddress(data)}
      {children}
    </Col>
  );
}

function renderImage(data, { imageAlign, searchURI, detailURI }) {
  const { extended } = data;
  const photo = extended && extended.photo ? extended.photo : data.photo;
  const officeDetailPath = URI(`/firm/${encodeURIComponent(data.id)}`)
    .search({
      searchURI,
      detailURI
    })
    .toString();
  return (
    <Col
      xs={6}
      className={cx(BS.textCenter, {
        [BS.pr1]: imageAlign === 'left'
      })}
    >
      <Link to={officeDetailPath}>
        <img
          src={photo ? `${PHOTO_BASE_URL}${photo}` : notfound}
          alt="Not Found"
          className={cx(BS.imgFluid, {
            [BS.b1]: !photo
          })}
          onError={e => {
            e.target.src = notfound;
            e.target.className = cx(e.target.className, BS.b1);
          }}
        />
      </Link>
    </Col>
  );
}

export default BrokerageCard;



// WEBPACK FOOTER //
// ./src/partials/brokerage-card/brokerage-card.js